var React = require('react');

function CrownInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.0002 8.23881C18.5228 6.94527 17.261 6 15.7606 6C13.868 6 12.3335 7.49254 12.3335 9.33333H14.0556C14.0556 8.42123 14.8228 7.67496 15.7777 7.67496C16.7325 7.67496 17.4997 8.42123 17.4997 9.33333L19.0002 8.23881Z","fill":"#333F48","key":0}),React.createElement("path",{"d":"M5.68687 11.0101H25.6798V16.6376L27.3004 15.7412L27.3169 11.0101H27.3335V9.3335H4.0332L4.00012 26.0002H20.5865V24.3733L5.71995 24.3899L5.68687 11.0101Z","fill":"#333F48","key":1}),React.createElement("path",{"d":"M25.7588 18.4776V24.4413H22.3335V25.9998H27.301L27.3335 17.6665L25.7588 18.4776Z","fill":"#21A038","key":2})]);
}

CrownInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CrownInline;

CrownInline.default = CrownInline;
